<script lang="ts">
  import { Popconfirm, PopconfirmProps } from 'ant-design-vue';
  import { computed, defineComponent, h, unref, useAttrs } from 'vue';
  import { extendSlots } from '@mts-fe/utils';
  import { t } from '@mts/hooks/web/useI18n';
  import MButton from './MButton.vue';

  const props = {
    /**
     * Whether to enable the drop-down menu
     * @default: true
     */
    enable: {
      type: Boolean,
      default: true,
    },
  };

  export default defineComponent({
    name: 'PopButton',
    inheritAttrs: false,
    props,
    setup(props, { slots }) {
      const attrs = useAttrs();

      const POPCONFIRM_OMIT = ['confirm', 'cancel'];
      const BUTTON_OMIT = ['title'];
      const POPCONFIRM_BIND_OMIT = ['icon', 'color'];

      const getBindValues = computed(() => {
        const values: Recordable = {};

        const attrKeys = Object.keys(attrs);
        for (const key of attrKeys) {
          if (!POPCONFIRM_OMIT.includes(key)) {
            values[key] = attrs[key];
          }
        }

        values.okText = t(values.okText || 'common.okText');
        values.cancelText = t(values.cancelText || 'common.cancelText');

        if (typeof values.title === 'string') {
          values.title = t(values.title);
        }
        return values as PopconfirmProps;
      });

      const getButtonProps = computed(() => {
        const values = unref(getBindValues);
        const buttonProps: Recordable = {};

        const omitSet = new Set(BUTTON_OMIT);
        const valueKeys = Object.keys(values);
        for (const key of valueKeys) {
          if (!omitSet.has(key)) {
            buttonProps[key] = values[key];
          }
        }

        if (buttonProps.disabled) {
          buttonProps.color = '';
        }
        return buttonProps;
      });

      const getPopconfirmProps = computed(() => {
        const values = unref(getBindValues);
        const popconfirmProps: Recordable = {};

        const omitSet = new Set(POPCONFIRM_BIND_OMIT);
        const valueKeys = Object.keys(values);
        for (const key of valueKeys) {
          if (!omitSet.has(key)) {
            popconfirmProps[key] = values[key];
          }
        }
        return popconfirmProps;
      });

      return () => {
        const ButtonVNode = h(MButton, getButtonProps.value, extendSlots(slots));

        if (!props.enable) return ButtonVNode;

        return h(Popconfirm, getPopconfirmProps.value, { default: () => ButtonVNode });
      };
    },
  });
</script>
